import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateWithDayOfWeek',
  standalone: true,
})
export class DateWithDayOfWeekPipe implements PipeTransform {

    transform(value: string): HTMLElement | string {
      // Ensure the value is a valid date string
      if (!value) return value;
  
      const date = new Date(value);
      
      // Check if the date is valid
      if (isNaN(date.getTime())) return value;
  
      // Get the day of the week
      const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'long' });
      
      // Format the date to MM/DD/YYYY
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // Adding leading zero for months < 10
      const day = ('0' + date.getDate()).slice(-2); // Adding leading zero for days < 10
      const year = date.getFullYear();
  
      // Return formatted date with the day of the week
      return `${month}/${day}/${year}<br>(${dayOfWeek})`;
    }
  
  }